import { TipoProtocolloEnum } from "@app/shared/enum/tipo-protocollo-enum";

import { SettoreVO } from "../settoreVO";

import { DocumentoVO } from "../documentoVO";

import { MetadatiProtocolloGescorVO } from "./metadati-protocollo-gescorVO";

import { ClassificaGescorVO } from "./classifica-gescorVO";

import { UtenteVO } from "../utenteVO";
import { DocumentoGescorVO } from "./documento-gescorVO";
import { DestinatarioDTO } from "@app/shared/dto/gescor/destinatarioDTO";
import { DestinatarioInternoDTO } from "@app/shared/dto/gescor/destinatario-internoDTO";
import { DestinatarioDipendenteDTO } from "@app/shared/dto/gescor/destinatario-dipendenteDTO";
import { DestinatarioVO } from "./destinatarioVO";
import { DestinatarioDipendenteVO } from "./destinatario-dipendenteVO";
import { DestinatarioInternoVO } from "./destinatario-internoVO";
import { MetadatiProtocolloVO } from "../metadati-protocolloVO";

export class CorrispondenzaPartenzaVO {
  id: string;

  idMittente: string;

  tipoProtocollo: TipoProtocolloEnum;

  tipoProtocolloAbbreviato: string;

  tipoProtocolloLabel: string;

  mittente: SettoreVO = new SettoreVO;

  oggetto: string;

  riservata: Boolean;

  primario: DocumentoGescorVO;

  metadatiProtocollo: MetadatiProtocolloGescorVO;

  allegati: DocumentoGescorVO[];

  destinatari: DestinatarioVO[];

  destinatariCartacei: DestinatarioVO[];

  destinatariString: string = "";

  destinatariInterni: DestinatarioInternoVO[];

  destinatariDipendenti: DestinatarioDipendenteVO[];

  classifica: ClassificaGescorVO[] = new Array<ClassificaGescorVO>();

  classificaInterna: ClassificaGescorVO[] = new Array<ClassificaGescorVO>();

  //   visibilitaPartenza: VisibilitaPartenzaDTO[];


  firmatario: UtenteVO;

  operatore: UtenteVO;

  numeroAllegati: number;

  descrizioneAllegati: string;

  stato: string;

  dataInserimento: string;

  //  datiFirma: DatiFirmaPartenzaDTO;

  //  statoPartenzaProtocollo: StatoPartenzaProtocolloDTO;

  //   richiesteAssociate: boolean;

  //   tipoRichieste: TipoRichiestaEnum[];
}
